import {
  ChallengeFaqFormValues,
  FaqFormValues,
} from '../../../../../../interfaces/ChallengeFormValues';
import {
  ChallengeFaqSection,
  FaqInfo,
} from '../../../../../../interfaces/SaveChallengeInfo';
import { challengeService } from '../../../../../../services/challengeService';

const processFaqs = (faqs: FaqInfo[]): FaqFormValues[] =>
  faqs.map((faq) => ({
    question: faq.question ?? '',
    answer: faq.answer ?? '',
    questionNum: faq.questionNum,
  }));

export const transformFaqsToFormValues = (
  faqsData: ChallengeFaqSection,
): { faqs: ChallengeFaqFormValues } => {
  return {
    faqs: {
      enabled: faqsData.enabled,
      faqs: processFaqs(faqsData.faqs ?? []),
    },
  };
};

export const getFaqFormValue = async (
  challengeId: number,
): Promise<{ faqs: ChallengeFaqFormValues }> => {
  const faqs = await challengeService.getChallengeFaqs(challengeId);
  return transformFaqsToFormValues(faqs);
};
